import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const normalizedEmail = (email || "").trim().toLowerCase();
      const { data } = await api.post("/admin/login", { email: normalizedEmail, password });
      localStorage.setItem("aiude_admin_token", data.token);
      localStorage.setItem("aiude_admin_email", data.admin.email);
      toast.success("Signed in");
      nav("/admin");
    } catch { toast.error("Invalid credentials"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto mt-20">
      <div className="panel-elev tick-brackets p-8">
        <div className="flex items-center gap-3 mb-6">
          <Lock className="w-5 h-5 text-[#00D2FF]" />
          <div>
            <div className="font-tech">Administrator</div>
            <h1 className="text-xl font-semibold text-white">Sign in</h1>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="label-cad">Email</label>
            <input className="input-cad" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" autoComplete="username" />
          </div>
          <div>
            <label className="label-cad">Password</label>
            <input className="input-cad" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" autoComplete="current-password" />
          </div>
          <button className="btn-primary w-full justify-center" disabled={loading} data-testid="admin-login-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </button>
        </form>
        <div className="mt-6 text-center">
          <a href="/admin/forgot" data-testid="admin-forgot-link" className="text-xs font-mono uppercase tracking-widest text-slate-400 hover:text-[#00D2FF]">
            Forgot or set password?
          </a>
        </div>
      </div>
    </div>
  );
}
